import * as Chart from 'chart.js';
import { ChartComponentProps } from 'react-chartjs-2';

export interface DefaultChartProps {
    width?: number;
    height?: number;
    options?: ChartComponentProps['options'];
    otherOptions?: DefaultChartOptions;
}
export interface DefaultChartOptions {
    hideXAxis?: boolean;
    hideYAxis?: boolean;
    yNoDecimals?: boolean;
}

export interface OverrideHelpers {
    xAxes?: Chart.ChartXAxe;
    yAxes?: Chart.ChartXAxe;
}

export function getOptionsForDefaultChartOptions({
    helpers,
    options,
    otherOptions,
}: {
    options?: ChartComponentProps['options'];
    otherOptions?: DefaultChartOptions;
    helpers?: OverrideHelpers;
}): Chart.ChartOptions {
    const { hideXAxis = false, hideYAxis = false, yNoDecimals = false } = otherOptions ?? {};
    const extraOptions: Chart.ChartOptions = options ?? {};

    let { xAxes, yAxes } = helpers ?? {};

    xAxes = {
        ...xAxes,
        ...extraOptions.scales?.xAxes?.[0],
    };
    yAxes = {
        ...yAxes,
        ...extraOptions.scales?.yAxes?.[0],
    };

    if (hideXAxis) {
        xAxes = {
            display: false,
            ...xAxes,
        };
    }

    if (hideYAxis) {
        yAxes = {
            display: false,
            ...yAxes,
        };
    }

    if (yNoDecimals) {
        yAxes = {
            ticks: {
                callback: label => (Number.isInteger(label) ? label : null),
            },
            ...yAxes,
        };
    }

    return {
        ...extraOptions,
        scales: {
            xAxes: [xAxes],
            yAxes: [yAxes],
        },
    };
}
